import ReactDOM from 'react-dom'
import React from 'react'
import App from './src/App'
import './src/styles.css'
import getComponent from '@polystack/admin/src/utils/component-helper'
import mergeWith from 'lodash/mergeWith'

const env = window.__polystack_data__ || {}
function joinUrl(part, p = location.pathname) {
  if(p === '/') return '/' + part
  return p.replace(/\/$/, '') + '/' + part
}
function cleanPath(p) {
  if(p?.length > 1) {
    return p.replace(/\/$/, '')
  }
  return p
}

if(env.isStaticSite) {
  let redir = env.sitePages?.[cleanPath(window.location.pathname)]?.redirectTo
  if(redir) window.history.replaceState({}, document.title, redir + window.location.search)
  Promise.all([
    fetch(`/_build/assignment/${env.assignmentVersionId}.json`).then(j => j.json()),
    fetch(joinUrl('props.json')).then(j => j.json()),
    ...(env.componentTypes || []).map(t => getComponent(t, true))
  ]).then(([store, pageProps]) => {
    
    if(!store.env.props) store.env.props = {}

    mergeWith(store.env.props , pageProps, (dest, src) => {
      if(Array.isArray(dest)) return src
    })

    ReactDOM.hydrate(
      <App store={store} env={{ ...store.env, ...env}} loading={false} />,
      document.getElementById('root')
    )   
  })
} else {
  ReactDOM.hydrate(
    <App />,
    document.getElementById('root')
  )
}

